export enum RulesEnum {
  EQUALS,
  NOT_EQUALS,
  TRUTHY,
  ARRAY_NOT_EMPTY
}
